import React from 'react';
import { Col, Placeholder, Row } from '@thd-olt-component-react/core-ui';

const JobPostingDetailsLoader = () => {
  return (
    <div data-testid="job-posting-detail-loader-skeleton">
      <Row>
        <Col sm={3} xs={12}>
          <Placeholder
            type="rect"
            height="600px"
            width="100%"
          />
        </Col>
        <Col sm={9} xs={12}>
          <TextFieldSkeleton />
          <TextFieldSkeleton />
          <TextFieldSkeleton />
        </Col>
      </Row>
    </div>
  );
};

const TextFieldSkeleton = ({ rows = 4 }) => {
  return (
    <div style={{ marginBottom: '20px' }}>
      <Placeholder type="rect" height={`${rows * 40}px`} width="100%" />
    </div>
  );
};

export default JobPostingDetailsLoader;
